module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_open_rate_efo-db7052e7abce4ecd9c95cfd253a7fff4.svg";